import { render } from "./GroupInvitationForm.vue?vue&type=template&id=35899237"
import script from "./GroupInvitationForm.vue?vue&type=script&lang=js"
export * from "./GroupInvitationForm.vue?vue&type=script&lang=js"

import "./GroupInvitationForm.vue?vue&type=style&index=0&id=35899237&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__